import { countryFromISO } from "@/utils/country";
import { currencyFromISO } from "@/utils/currency";
import { Carrier } from "@babackapp/private-api-client/types";
import { ArrowRightIcon, PencilIcon, TrashIcon } from "lucide-react";
import { Button } from "@babackapp/ui/components/button";
import { useCarriersContext } from "../../use-carriers-context";
import { useState } from "react";
import { cn } from "@/utils/cn";
import useTranslation from "@babackapp/translations/use-translation";
import { PricingEdition } from "../forms/pricings-form";
import _ from "lodash";

export const PricingByCarrier = ({ carrier }: { carrier: Carrier }) => {
  const t = useTranslation();
  const { shop, editCarrierPricingsTransport, deleteCarrierPricing } =
    useCarriersContext();
  const [creatingIsOpen, setCreatingIsOpen] = useState(false);
  const [editingPricingIndex, setEditingPricingIndex] = useState(-1);
  if (!shop) return <></>;

  return (
    <div className="sm:items-start sm:border-t sm:border-gray-200 sm:pt-4 mt-1 space-y-1">
      <div
        className={cn(
          "flex justify-between align-center",
          creatingIsOpen
            ? "flex-col"
            : "flex-row sm:items-start sm:border-b sm:border-gray-200 sm:pt-4 mt-1 space-y-1",
        )}
      >
        <label
          htmlFor="carrier"
          className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
        >
          {carrier.code.toUpperCase()}
        </label>
        <div className="pb-2">
          {creatingIsOpen ? (
            <PricingEdition
              carrier={carrier}
              shop={shop}
              setEditingIsOpen={setCreatingIsOpen}
              onSubmit={editCarrierPricingsTransport}
            />
          ) : (
            <Button
              variant="default"
              size="sm"
              onClick={() => {
                setCreatingIsOpen(true)
              }}
            >
              {t("settings.carriers.newPricing")}
            </Button>
          )}
        </div>
      </div>

      <div className="mt-1 sm:mt-0 sm:col-span-2 space-y-2">
        {carrier.pricings.map((pricing, index) => (
          <div key={index}>
            {editingPricingIndex == index ? (
              <PricingEdition
                carrier={carrier}
                pricing={pricing}
                shop={shop}
                setEditingIsOpen={setCreatingIsOpen}
                setEditingPricingIndex={setEditingPricingIndex}
                onSubmit={editCarrierPricingsTransport}
                key={carrier.id}
              />
            ) : (
              <div className="flex items-center space-x-2 hover:bg-gray-50 py-1 -mx-4 px-4 rounded-md text-sm">
                <div className="text-left w-1/5">
                  {countryFromISO(pricing.origin)}
                </div>
                <div className="text-center flex">
                  <ArrowRightIcon className="h-4 m-auto text-gray-400"/>
                </div>
                <div className="text-right w-1/5">
                  {countryFromISO(pricing.destination)}
                </div>
                <div className="text-right w-1/5">
                  {pricing.price.toFixed(2)} {currencyFromISO(pricing.currency)}
                </div>
                <div className="text-right grow">
                  <Button
                    variant="ghost"
                    size="icon"
                    type="button"
                    className="text-primary"
                    onClick={() => {
                      setEditingPricingIndex(index);
                    }}>
                    <PencilIcon className="h-4 w-4"/>
                  </Button>
                  <Button
                    variant="ghost"
                    size="icon"
                    type="button"
                    className="text-primary"
                    onClick={() => {
                      deleteCarrierPricing({
                        carrierId: carrier.id,
                        carrierPricingId: pricing.id,
                      });
                    }}>
                    <TrashIcon className="h-4 w-4"/>
                  </Button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
